import { Box } from "@mantine/core";

import classes from "./paper-frame.module.css";

export const PaperFrame = (props) => {
    return (<Box className={classes.root} {...props} />);
}